import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=10f5bc52&scoped=true"
import script from "./ContractsList.vue?vue&type=script&lang=js"
export * from "./ContractsList.vue?vue&type=script&lang=js"
import style0 from "./ContractsList.vue?vue&type=style&index=0&id=10f5bc52&prod&lang=scss&scoped=true"
import style1 from "./ContractsList.vue?vue&type=style&index=1&id=10f5bc52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5bc52",
  null
  
)

export default component.exports